//Event types that has been counted in ActivityOptions.vue
export const countedEventTypes = {
  visit: {
    text: 'Visit'
  },
  contact_comments: {
    text: 'Contact Comments'
  },
  email_sent: {
    text: 'Email Sent'
  },
  email_received: {
    text: 'Email Received'
  },
  email_3rd_party: {
    text: 'Email Sent via 3rd Party'
  },
  text_sent: {
    text: 'Text Sent'
  },
  text_received: {
    text: 'Text Received'
  },
  inbound_call: {
    text: 'Inbound Call'
  },
  outbound_call: {
    text: 'Outbound Click to Call'
  }
}
